"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../../Auth/utils");
const react_router_dom_1 = require("react-router-dom");
const Grid_1 = __importDefault(require("./Grid"));
const List_1 = __importDefault(require("../../components/OrderHistory/List"));
const permissions_1 = require("../../types/permissions");
const OrderHistory = ({ match }) => {
    const { path } = match;
    const { user } = (0, AuthContext_1.useAuth)();
    return ((0, utils_1.isAllowed)(user, [permissions_1.OrdersPermissions.READ_ORDER_COMPLETE_HISTORY, permissions_1.OrdersPermissions.READ_ORDER_COMPANY_HISTORY]) ? (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: path, component: List_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: `${path}/:orderId`, component: Grid_1.default }))) : null);
};
exports.default = OrderHistory;
